import { IfQuickReloadFlushEverything } from "./cache.js";
import { controlStartUp } from "./control.js";
import { i18nGetPageLanguage } from "./i18n.js";
import { pageFetchPosters, pageGetPostersNumber } from "./page.js";
import { posterAppendAuthor, posterParse, posterRender } from "./poster.js";
import {
    postersSetIndexMode,
    postersSetPublisherFilter,
    postersUnescapeSpacesAndApostrophes
} from "./posters.js";

function spaceShowEmptyMessage(wrapper) {
    const element = document.createElement("p");
    element.className = "spacePageEmpty";
    element.textContent = i18nGetPageLanguage() === "es"
        ? "Ahora mismo no hay carteles publicados en esta sección."
        : "Ara mateix no hi ha cartells publicats en aquesta secció.";
    wrapper.appendChild(element);
}

function spaceParsePosterDate(value) {
    const parts = typeof value === "string" ? value.split("/") : [];
    if (parts.length !== 3) {
        return null;
    }
    const date = new Date(Number(parts[2]), Number(parts[1]) - 1, Number(parts[0]));
    return Number.isNaN(date.getTime()) ? null : date;
}

function spaceTemporalSkipPoster() {
    const requested = new URL(document.location).searchParams.get("from")
        || document.getElementById("listingDateFrom")?.value;
    if (!/^\d{4}-\d{2}-\d{2}$/.test(requested || "")) {
        return null;
    }
    const parts = requested.split("-");
    const threshold = new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));
    return (poster) => {
        const end = spaceParsePosterDate(poster.dateEnd) || spaceParsePosterDate(poster.dateBegin);
        return end !== null && end.getTime() < threshold.getTime();
    };
}

async function spaceStartUp(publisherId, escapedSuperLabel) {
    const wrapper = document.getElementById("mainPostersWrapper");
    const loader = document.getElementById("mainLoader");
    if (!wrapper) {
        return;
    }

    if (wrapper.dataset.postersLoaded === "true") {
        posterRender(wrapper);
        Array.from(wrapper.getElementsByClassName("posterWrapper")).forEach((poster) => {
            posterAppendAuthor(poster);
            posterParse(poster);
        });
        return;
    }

    if (loader) {
        loader.style.display = "inline-block";
    }
    if (await IfQuickReloadFlushEverything()) {
        return;
    }

    const superLabel = postersUnescapeSpacesAndApostrophes(escapedSuperLabel || "");
    controlStartUp("mainSentinel");
    postersSetIndexMode("main");
    try {
        await pageFetchPosters(wrapper, "", "", superLabel, 0, "", null, {
            forceFullPage: true,
            publisherId: publisherId || "",
            targetPostersNumber: 20,
            skipPoster: spaceTemporalSkipPoster()
        });
        if (pageGetPostersNumber() === 0) {
            spaceShowEmptyMessage(wrapper);
        }
        wrapper.dataset.postersLoaded = "true";
    } finally {
        postersSetPublisherFilter("");
        if (loader) {
            loader.style.display = "none";
        }
    }
}

export { spaceStartUp };
